import PropTypes from "prop-types";

import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase";

export const DrawerModuleContent = ({ items, onItemClick, interpolateUrl, analyticsData }) => {
  const handleClick = (item) => {
    if (analyticsData.mail) {
      logEvent(analytics, "drawer_item_clicked", {
        itemName: item.FCTERCERASECCION,
        action: item.FCJSONSECCION3,
        ...analyticsData,
      });
    }
    onItemClick(item);
  };

  const isExternalLink = (actionType) => {
    return (
      actionType === "navigateToChildsMesaServicios" || actionType === "navigateToFuncionWithData"
    );
  };

  const getInterpolatedUrl = (item) => {
    if (!isExternalLink(item.FCJSONSECCION3)) return null;
    return interpolateUrl(item.FCLINKSECCION3);
  };

  return (
    <div className="drawer-module-grid">
      {items.map((item) => {
        const href = getInterpolatedUrl(item);
        const isLink = isExternalLink(item.FCJSONSECCION3);

        const CardContent = () => (
          <>
            <div className="drawer-item-icon">
              <img src={item.FCURLIMAGEN3} alt={item.FCTERCERASECCION} />
            </div>
            <div className="drawer-item-label">{item.FCTERCERASECCION}</div>
          </>
        );

        if (isLink && href) {
          return (
            <a
              key={item.FCKEY || item.FITERCERASECCION}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="drawer-item-card"
              onClick={() => handleClick(item)}
            >
              <CardContent />
            </a>
          );
        }

        return (
          <button
            key={item.FCKEY || item.FITERCERASECCION}
            className="drawer-item-card"
            onClick={() => handleClick(item)}
          >
            <CardContent />
          </button>
        );
      })}
    </div>
  );
};

DrawerModuleContent.propTypes = {
  items: PropTypes.array.isRequired,
  onItemClick: PropTypes.func.isRequired,
  interpolateUrl: PropTypes.func.isRequired,
  analyticsData: PropTypes.object,
};
